import { CurrentUserContext } from "@/contexts/CurrentUser"
import { useContext } from "react"

export const useCurrentUser = () => {
  const context = useContext(CurrentUserContext)
  if (!context) {
    throw new Error("useCurrentUser must be used within a CurrentUserProvider")
  }
  return context
}

export default useCurrentUser
